import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../assets/css/login.css';
import API from '../api/axios';
import jbAPI from '../api/jobboard';

const Login = () => {
    const [step, setStep] = useState(1);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [secretQuestion, setSecretQuestion] = useState("");
    const [secretAnswer, setSecretAnswer] = useState('');
    const [otp, setOtp] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState();
    const navigate = useNavigate();
    const [message, setMessage] = useState({ type: "", text: "" });
    const APP_ID = process.env.REACT_APP_APP_ID;
    const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('token'); // or check auth state
    if (isLoggedIn) {
      navigate('/home');
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post('/login', { email, password, app_id: APP_ID, }); // POST /api/login
      console.log("RES :::: ", res);
      if (res.data.message) {
        setSecretQuestion(res.data.secretQuestion);
        setEmail(res.data.email);
        setStep(2);
      } else {
        // alert('Login failed');
        setMessage({ type: "danger", text: "Login failed" });
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        // alert(error.response.data.error); // This will show "User not found"
        setMessage({ type: "danger", text: error.response.data.error });
      } else {
        // alert("Something went wrong. Please try again.");
        setMessage({ type: "danger", text: "Something went wrong. Please try again." });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSecretAnswer = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post('/verify-secret', { email, secretAnswer }); // POST /api/verify-secret
      if (res.data.success) {

        // Assume backend sends OTP here
        setStep(3);
        setMessage({ type: "success", text: "OTP sent successfully." });
      } else {
        // alert('Incorrect secret answer');
        setMessage({ type: "danger", text: "Incorrect secret answer" });
      }
    } catch (error) {
      console.error(error);
      // alert('Verification error');
      setMessage({ type: "danger", text: "Verification error" });
    } finally {
      setLoading(false);
    }
  };

  const handleOtpVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await API.post('/verify-otp', { email, otp }); // POST /api/verify-otp
       console.log("RES :", res);
      if (res.data.token) {
         const profilePicUrl = res.data.profilePic
          ? `${process.env.REACT_APP_C2AS_UPLOAD_URL}/${res.data.profilePic}`
          : null;
        localStorage.setItem('otoken', res.data.token);
        localStorage.setItem('flag', res.data.success);
        localStorage.setItem('play', res.data.role);
        localStorage.setItem('msg', res.data.message);
        localStorage.setItem('aId',APP_ID);
        localStorage.setItem('aUId',res.data.AppUserId);
        localStorage.setItem('name',res.data.fullName);
        localStorage.setItem('uId',res.data.userId);
        localStorage.setItem('email', email);
        localStorage.setItem('profilePic', profilePicUrl);
       // Fetch employer profile to get company_id
        if(res.data.role === "employer")
        {
          const profileRes = await jbAPI.get(`/employer/${res.data.AppUserId}/profile`, {
            headers: {
              Authorization: `Bearer ${res.data.token}`,
            },
          });
          const { company_id } = profileRes.data.company;
          localStorage.setItem("companyId", company_id);
          localStorage.setItem("companyName", profileRes.data.company.company_name);
        }
        if(res.data.role === "jobSeeker")
        {
          console.log("res.data.role ::: ",res.data.role);
          const profileRes = await jbAPI.get(`/candidate/${res.data.AppUserId}/profile`, {
            headers: {
              Authorization: `Bearer ${res.data.token}`,
            },
          });
        }
        navigate('/home');
      } else {
        // alert('Invalid OTP');
        setMessage({ type: "danger", text: "Invalid OTP" });
      }
    } catch (error) {
      console.error(error);
      // alert('OTP verification error');
      setMessage({ type: "danger", text: "OTP verification error" });
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
    {/* <div id="preloader">
        <div className="loader">
            <svg className="circular" viewBox="25 25 50 50">
                <circle className="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
            </svg>
        </div>
    </div> */}
    <div className="login-form-bg h-100">
        <div className="container h-100">
            <div className="row justify-content-center h-100">
                <div className="col-xl-6">
                    <div className="form-input-content">
                        <div className="card login-card login-form mb-0">
                            <div className="card-body pt-5">
                                {/* <a className="text-center" href="/"> <h4>{process.env.REACT_APP_APPL_NAME}</h4></a> */}
                                 <img src="/assets/img/logo-preview.png" alt="Logo"
                                  className='d-block mx-auto'
                                  style={{
                                    backgroundColor: 'transparent', // or match the parent background
                                    mixBlendMode: 'multiply' // optional: blends black out on light background
                                  }}/>
                                {message.text && (
                                    <div className={`alert alert-${message.type} mt-3`} role="alert">
                                      {message.text}
                                    </div>
                                
                                )}
                                {step === 1 && (
                    <form className="mt-5 mb-5 login-input" onSubmit={handleLogin}>
                      <div className="input-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <br/>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                        <span
                          className="input-group-text"
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: "pointer" }}
                        >
                        <i
                          className={`fa fa-solid ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                        />
                        </span>
                      </div>
                      <br/>
                      <button type="submit" className="btn btn-primary w-100">Sign In</button>
                    </form>
                  )}

                  {step === 2 && (
                    <form className="mt-5 mb-5 login-input" onSubmit={handleSecretAnswer}>
                      <p>{secretQuestion}</p>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Secret Answer"
                          value={secretAnswer}
                          onChange={(e) => setSecretAnswer(e.target.value)}
                          required
                        />
                      </div>
                      <button type="submit" className="btn btn-primary w-100">Submit Answer</button>
                    </form>
                  )}

                  {step === 3 && (
                    <form className="mt-5 mb-5 login-input" onSubmit={handleOtpVerify}>
                      <p>Enter OTP sent to your registered email & mobile</p>
                      <div className="form-group">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="OTP"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          required
                        />
                      </div>
                      <button type="submit" className="btn btn-primary w-100">Verify OTP</button>
                    </form>
                  )}

                  
                    <p className="mt-5 login-form__footer">
                      Don’t have an account? <Link to="/signup" className="text-primary">Sign Up</Link> now
                    </p>
                    <p className="mt-2 login-form__footer">
                          <Link to="/forgot-password" className="text-primary">
                            Forgot Password?
                          </Link>
                    </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};

export default Login;
